/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CrmType} from '../models/CrmType';
import type {Error} from '../models/Error';
import type {ImportSyncedEntitiesData} from '../models/ImportSyncedEntitiesData';

export interface GetImportSyncedEntitiesData$Request {
    accountId: number;
    targetLicenseId: number;
    crmType: CrmType;
}

export interface GetImportSyncedEntitiesData$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getImportSyncedEntitiesDataRequest = createAction<PayloadData<void, GetImportSyncedEntitiesData$Request>>('IMPORT_SYNCED_ENTITIES__GET_IMPORT_SYNCED_ENTITIES_DATA__REQUEST');
export const getImportSyncedEntitiesDataSuccess = createAction<PayloadData<Array<ImportSyncedEntitiesData>, GetImportSyncedEntitiesData$Request>>('IMPORT_SYNCED_ENTITIES__GET_IMPORT_SYNCED_ENTITIES_DATA__SUCCESS');
export const getImportSyncedEntitiesDataFailure = createAction<PayloadData<Error, GetImportSyncedEntitiesData$Request, true>>('IMPORT_SYNCED_ENTITIES__GET_IMPORT_SYNCED_ENTITIES_DATA__FAILURE');

export const getImportSyncedEntitiesDataActions = [
    getImportSyncedEntitiesDataRequest,
    getImportSyncedEntitiesDataSuccess,
    getImportSyncedEntitiesDataFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.targetLicenseId
 * @param {CrmType} meta.crmType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getImportSyncedEntitiesData = (meta: GetImportSyncedEntitiesData$Request, config?: GetImportSyncedEntitiesData$Config) => {
    const TRANSPORT_GET_PARAMS = {
        targetLicenseId: meta.targetLicenseId,
    };
    return {
        CALL_API: {
            types: getImportSyncedEntitiesDataActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/import-synced-entities/${meta.crmType}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ImportSyncedEntitiesData$Request {
    accountId: number;
    sourceLicenseId: number;
    targetLicenseId: number;
    crmType: CrmType;
}

export interface ImportSyncedEntitiesData$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const importSyncedEntitiesDataRequest = createAction<PayloadData<void, ImportSyncedEntitiesData$Request>>('IMPORT_SYNCED_ENTITIES__IMPORT_SYNCED_ENTITIES_DATA__REQUEST');
export const importSyncedEntitiesDataSuccess = createAction<PayloadData<void, ImportSyncedEntitiesData$Request>>('IMPORT_SYNCED_ENTITIES__IMPORT_SYNCED_ENTITIES_DATA__SUCCESS');
export const importSyncedEntitiesDataFailure = createAction<PayloadData<Error, ImportSyncedEntitiesData$Request, true>>('IMPORT_SYNCED_ENTITIES__IMPORT_SYNCED_ENTITIES_DATA__FAILURE');

export const importSyncedEntitiesDataActions = [
    importSyncedEntitiesDataRequest,
    importSyncedEntitiesDataSuccess,
    importSyncedEntitiesDataFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {number} meta.sourceLicenseId
 * @param {number} meta.targetLicenseId
 * @param {CrmType} meta.crmType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const importSyncedEntitiesData = (meta: ImportSyncedEntitiesData$Request, config?: ImportSyncedEntitiesData$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sourceLicenseId: meta.sourceLicenseId,
        targetLicenseId: meta.targetLicenseId,
    };
    return {
        CALL_API: {
            types: importSyncedEntitiesDataActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/crm/${meta.accountId}/import-synced-entities/${meta.crmType}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

